<la-document-upload-dialog
  #documentUpload
  (filesChanged)="onFilesChanged($event)"
>
  <mat-table [dataSource]="fileDataSource" [seperation]="'divider'">
    <ng-container matColumnDef="document">
      <mat-header-cell *matHeaderCellDef i18n>Document</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="truncate fw-b" [matTooltip]="element.document.name">
          {{ element.document.name }}
        </div>
      </mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="remove">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index">
        <button
          luiIconButton
          size="sm"
          (click)="documentUpload.removeDocument(element.document, index)"
          aria-label="Delete"
          i18n-aria-label
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedCols"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
  </mat-table>
</la-document-upload-dialog>
